import { LineSkeleton } from 'components/base/Skeletons';
import styled from 'styled-components';

const StyledLabelListTooltipLoader = styled.div``;

const LabelListTooltipLoader = () => {
  return (
    <StyledLabelListTooltipLoader>
      <LineSkeleton width={100} />
    </StyledLabelListTooltipLoader>
  );
};

export default LabelListTooltipLoader;
